import React, { useEffect, useState } from "react";
import {
    IonPage,
    IonContent,
    IonCard,
    IonCardContent,
    IonButton,
    IonLabel,
    IonItem,
    IonRadioGroup,
    IonRadio,
    IonText,
    IonAlert,
} from "@ionic/react";

interface QuestionData {
    title: string;
    content: string;
    questions: QuestionSubData[];
}

interface QuestionSubData {
    questionText: string;
    correctAnswer: string;
    options: string[];
}


const ReadingComprehensionWorksheet: React.FC = () => {
    // Dynamic story and questions

    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [selectedOption, setSelectedOption] = useState<string | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [questions, setQuestions] = useState<QuestionData[]>([]);
    const [userAnswer, setUserAnswer] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [error, setError] = useState(false);

    const shuffleArray = (array: any[]) => {
        for (let i = array.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i + 1));
            [array[i], array[randomIndex]] = [array[randomIndex], array[i]];
        }
        return array;
    };

    // Handle Submit Answer
    const handleSubmit = (option: any) => {
        setSelectedOption(option)
        if (option === questions[currentIndex]?.questions[currentQuestionIndex].correctAnswer) {

            if (currentQuestionIndex < questions[currentIndex]?.questions.length - 1) {
                setTimeout(() => {
                    setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
                }, 1000); // Delay reduced to 3 seconds
            } else {
                setShowImage(true);
                console.log(currentIndex);
                setTimeout(() => {
                    if (currentIndex === questions.length - 1) {
                        setCurrentIndex(0);
                        fetchQuestions();
                    }
                    else {
                        setCurrentIndex(currentIndex + 1);
                    }
                    setError(false);
                    setCurrentQuestionIndex(0);
                    setShowImage(false);
                }, 5000); // Delay reduced to 3 seconds
            }
            setUserAnswer('');
        }
    };

    const fetchQuestions = async () => {
        try {
            let data: QuestionData[] = [];

            if (process.env.REACT_APP_DEVELOPMENT !== 'WEB') {
                const response = await fetch(process.env.REACT_APP_API_URL + 'ReadingComprehensionWorksheet.json');
                data = await response.json();
            } else {
                const module = await import('../../../datas/ReadingComprehensionWorksheet.json');
                data = module.default;
            }

            const shuffledQuestions = shuffleArray(data);
            setQuestions(shuffledQuestions);
        } catch (error) {
            console.error('Error loading data:', error);
        }
    };

    useEffect(() => {
        fetchQuestions();
        document.title = "Mamas Guidance - Class One - English - Reading Comprehension"; // Set page title
    }, []);

    return (
        <>
            {showImage === false ? (
                <>
                    <div className="contentPart showCenter fillPreposition additionWord" style={{ padding: "0%" }}>
                        <h3>{questions[currentIndex]?.title}</h3>
                        <p>
                            <strong>Story:</strong>
                            <br />
                            <IonText>{questions[currentIndex]?.content}</IonText>
                        </p>

                        <h4>{questions[currentIndex]?.questions[currentQuestionIndex]?.questionText}</h4>
                        <div className="mb-5">
                            <IonRadioGroup
                                value={selectedOption}
                                onIonChange={(e) => handleSubmit(e.detail.value)}
                            >
                                {questions[currentIndex]?.questions[currentQuestionIndex]?.options.map((option, index) => (
                                    <IonItem
                                        className={` ${selectedOption === option
                                                ? option === questions[currentIndex]?.questions[currentQuestionIndex]?.correctAnswer
                                                    ? "correct"
                                                    : "errorItems"
                                                : ""
                                            }`}
                                        key={index}>
                                        <IonLabel>{option}</IonLabel>
                                        <IonRadio slot="start" value={option} />
                                    </IonItem>
                                ))}
                            </IonRadioGroup>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="contentPart showMiddle">
                        <img
                            style={{ height: "150px" }}
                            className="img-fluid"
                            src={process.env.REACT_APP_WELDONE_LINK}
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default ReadingComprehensionWorksheet;
